import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { environment } from '../../../../environments/environment';

@Component({
  imports: [CommonModule],
  templateUrl: './rl-operacao.component.html',
  styleUrls: ['./rl-operacao.component.scss'],
})
export class OperacaoComponent implements AfterViewInit {
  @ViewChild('frame')
  frame!: ElementRef;

  ngAfterViewInit() {
    const { src } = this.frame.nativeElement;
    const { reporstRefreshTimeout } = environment;

    window.setInterval(() => (this.frame.nativeElement.src = src), reporstRefreshTimeout);
  }
}
